import React from "react";
import PropTypes from "prop-types";
import { ColumnDefaultProps, ColumnPropTypes } from "../../../props";

import { v4 as uuidv4 } from "uuid";
import classNames from "classnames";

import Content from "./content";
import Prefix from "./prefix";
import Suffix from "./suffix";

function Th({ column, i, item }) {
  let tdClasses = classNames(
    {
      [`text-${column.text}`]: column.text
    },
    column.className || ""
  );

  return (
    <th
      key={column.id || uuidv4()}
      className={tdClasses}
      colSpan={column.colSpan || null}
      rowSpan={column.rowSpan || null}
    >
      <div className="th-wrapper">
        <div className="th-positioner">
          <div className="th-dots">
            <Prefix content={column.prefix} />
          </div>
          <div className="th-dots">
            <span className="title">
              {item ? (
                <Content column={column} item={item} i={i} />
              ) : (
                column.title || ""
              )}
            </span>
          </div>
          <div className="th-dots">
            <Suffix content={column.suffix} />
          </div>
        </div>
      </div>
    </th>
  );
}

Th.defaultProps = {
  column: ColumnDefaultProps,
  item: null
};

Th.propTypes = {
  i: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isRender: PropTypes.bool,
  column: ColumnPropTypes,
  item: PropTypes.object
};

export default Th;
